module.exports = __webpack_public_path__ + "static/media/intro_wall1.8c9423ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/Conviot/Intro/img/intro_wall1.png
// module id = 185
// module chunks = 0